export const eventList: Record<keyof GlobalEventHandlersEventMap, true> = {
  abort: true,
  animationcancel: true,
  animationend: true,
  animationiteration: true,
  animationstart: true,
  auxclick: true,
  beforeinput: true,
  beforetoggle: true,
  blur: true,
  cancel: true,
  canplay: true,
  canplaythrough: true,
  change: true,
  click: true,
  close: true,
  command: true,
  compositionend: true,
  compositionstart: true,
  compositionupdate: true,
  contextlost: true,
  contextmenu: true,
  contextrestored: true,
  copy: true,
  cuechange: true,
  cut: true,
  dblclick: true,
  drag: true,
  dragend: true,
  dragenter: true,
  dragleave: true,
  dragover: true,
  dragstart: true,
  drop: true,
  durationchange: true,
  emptied: true,
  ended: true,
  error: true,
  focus: true,
  focusin: true,
  focusout: true,
  formdata: true,
  gotpointercapture: true,
  input: true,
  invalid: true,
  keydown: true,
  keypress: true,
  keyup: true,
  load: true,
  loadeddata: true,
  loadedmetadata: true,
  loadstart: true,
  lostpointercapture: true,
  mousedown: true,
  mouseenter: true,
  mouseleave: true,
  mousemove: true,
  mouseout: true,
  mouseover: true,
  mouseup: true,
  paste: true,
  pause: true,
  play: true,
  playing: true,
  pointercancel: true,
  pointerdown: true,
  pointerenter: true,
  pointerleave: true,
  pointermove: true,
  pointerout: true,
  pointerover: true,
  pointerup: true,
  progress: true,
  ratechange: true,
  reset: true,
  resize: true,
  scroll: true,
  scrollend: true,
  securitypolicyviolation: true,
  seeked: true,
  seeking: true,
  select: true,
  selectionchange: true,
  selectstart: true,
  slotchange: true,
  stalled: true,
  submit: true,
  suspend: true,
  timeupdate: true,
  toggle: true,
  touchcancel: true,
  touchend: true,
  touchmove: true,
  touchstart: true,
  transitioncancel: true,
  transitionend: true,
  transitionrun: true,
  transitionstart: true,
  volumechange: true,
  waiting: true,
  webkitanimationend: true,
  webkitanimationiteration: true,
  webkitanimationstart: true,
  webkittransitionend: true,
  wheel: true,
  beforematch: true,
  pointerrawupdate: true,
};
